import styled from 'styled-components'

export const StyledRegulation = styled.div`
	strong {
		font-size: 22px;
		line-height: 60px;
	}

	li {
		font-size: 20px;
		line-height: 28px;
		margin-bottom: 10px;
	}

	p {
		font-size: 20px;
		text-align: justify;
		font-weight: 600;
	}
`
